import React from 'react';

import { AvailableTablesProps } from 'interfaces/report-configuration.interface';

import TableItem from './AvailableTablesRow';

const AvailableTables: React.FC<AvailableTablesProps> = ({ tables, onSelect, selectedTable }) => {
  return (
    <div className="border border-neutral-200 dark:border-neutral-800 flex flex-col rounded-lg px-5 py-2.5 h-[65vh] md:w-1/2">
      <p className="text-sm mb-2">Available Tables</p>
      <ul className="overflow-y-auto h-full">
        {tables.map(({ tableName, selectedColumns, totalColumns }) => (
          <TableItem
            key={tableName}
            tableName={tableName}
            selectedColumns={selectedColumns}
            totalColumns={totalColumns}
            isSelected={selectedTable === tableName}
            onSelect={() => onSelect(tableName)}
          />
        ))}
      </ul>
    </div>
  );
};

export default AvailableTables;
